import { Stack, StackItem } from '@fluentui/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React, { useMemo } from 'react';
import alarme from '../../../assets/icons/json/alarme-red.json';

const NotificationBar = (props) => {

    const { children } = props;

    const styles = useMemo(
        () => {
            let styles = {
                children: {
                    root: {
                        paddingBottom: 8,
                        paddingTop: 8,
                    }
                },
                outer: {
                    root: {
                        background: "#ECECEC",
                        borderLeft: "2px solid red",
                        gap: 13,
                        paddingLeft: 14,
                        paddingRight: 14,
                        width: "100%",
                    }
                },
            };

            return styles;
        },
        []
    );

    return <Stack
        horizontal
        styles={styles.outer}
        verticalAlign="center"
    >
        <Player autoplay src={alarme} style={{ width: 40 }} />
        <StackItem styles={styles.children}>
            {children}
        </StackItem>
    </Stack>;

};

export default NotificationBar;